export const getOriginalJudgement = (caseDescription) => {
  const parts = caseDescription?.split(/ORDER|JUDGEMENT|JUDGMENT|Judgment/);

  const originalJudgement = parts?.[1] ? parts[1].trim() : "";

  return originalJudgement ? originalJudgement : caseDescription;
};
